import * as React from "react";
import { Link } from "react-router-dom";
import { IPortalAppContext } from "./appContext";
import './portalSiteLinks.less'

interface Props {
  context: IPortalAppContext;
}

export function PortalSiteLinks(props: Props) {
  return (
    <div>      
      <Link to="/" className="portal-site-link-button">
        <i className="home-icon" />
        <span>Sexual Assault Forensic Examination Reimbursement Portal</span>        
      </Link>
    </div>
  );
}
